import axios from 'axios';
import { FormData } from '../types/FormData';

declare let window: { appConfig: { apiGatewayUrl: string } };

export async function submitHotelForm(formData: FormData): Promise<string> {
  const url = `${window.appConfig.apiGatewayUrl}/frontend/hotels/${formData.id}/qna`;
  const response = await axios({
    url,
    method: 'POST',
    headers: {
      'Content-type': 'application/json; charset=utf-8',
    },
    data: {
      question: formData.message,
      questionerEmail: formData.email,
      questionerPhone: formData.phone,
    },
  });
  const data = response.data;
  if (data?.success) {
    return data.result;
  }
  throw new Error(`Ошибка отправки вопроса`);
}
